import { render, staticRenderFns } from "./example-layout.vue?vue&type=template&id=cc306788"
import script from "./example-layout.vue?vue&type=script&lang=js"
export * from "./example-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports